import { type FC } from 'react';
import { MapFeature } from '~/_shared/types/toolsAndFeatures/mapFeatures.types';
import { useIsDataExportAllowed } from '~/_shared/types/toolsAndFeatures/useIsDataExportAllowed';
import { useLassoToolModal } from '~/map/map/lassoTool/useLassoToolModal';
import { useIsMobileToolPanelOpen } from '~/map/mapToolControls/useIsMobileToolPanelOpen.hook';
import { useIsMobileScreenSelector } from '~/store/frontendState/deviceInfo/deviceInfo.selector';
import { useSlidingAnimationMsDuration } from '~/store/frontendState/graphicSettings/graphicSettings.selectors';
import { useStreetViewSelector } from '~/store/frontendState/mapTools/streetView/streetView.selectors';
import { useIsConnectedLayeredMapSelector } from '~/store/mapInfo/mapInfo.selectors';
import { usePublicMapSettingsSelector } from '~/store/mapSettings/publicMapSettings/mapSettingsPublicMapSettings.selectors';
import {
  useIsMapEditDisabled, useIsMapPresentationalSelector,
} from '~/store/selectors/useMapInfoSelectors';
import { RightSideMapToolsComponent } from './rightSideMapTools.component';

export const RightSideMapToolsContainer: FC = () => {
  const publicMapSettings = usePublicMapSettingsSelector();
  const streetView = useStreetViewSelector();
  const isMapPresentational = useIsMapPresentationalSelector();
  const isLayeredMapConnected = useIsConnectedLayeredMapSelector();
  const isMobileScreen = useIsMobileScreenSelector();
  const isMobileToolPanelOpen = useIsMobileToolPanelOpen();
  const isEditModeDisabled = useIsMapEditDisabled();
  const hideLassoDueNoActions = !useLassoToolModal().allowedLassoActions.length;
  const isDataExportAllowed = useIsDataExportAllowed(MapFeature.ExportData);
  const transitionDurationMs = useSlidingAnimationMsDuration();

  return (
    <RightSideMapToolsComponent
      isExportDataEnabled={isDataExportAllowed}
      forceHideLasso={hideLassoDueNoActions}
      isEditModeDisabled={isEditModeDisabled}
      isMapPresentational={isMapPresentational}
      isLayeredMapConnected={isLayeredMapConnected}
      isMobileScreen={isMobileScreen}
      isMobileToolPanelOpen={isMobileToolPanelOpen}
      publicMapSettings={publicMapSettings}
      streetView={streetView}
      transitionDurationMs={transitionDurationMs}
    />
  );
};
